import React, { useEffect, useState } from 'react';
import { Space, Typography, Col, Row, Divider, Grid, Alert, Button } from 'antd';
import { useNavigate, useParams } from "react-router-dom";
import { hooks, models } from "@vote4dance/judging-sdk";
import { _T } from "../../../../base-react/src/Localization";
import { RoundPriorityType } from "@vote4dance/judging-types";
import { RoundResult } from './components/RoundResult';
import { RoundStatusView } from './components/RoundStatusView';
import { SendTeamsThrough } from './components/SendTeamsThrough';
import { JudgingType, RoundStatus, RoundType } from '@vote4dance/judging-schema';
var Stream = hooks.streams.Stream;
var FloorSource = models.floors.FloorSource;
var ClassRoundSource = models.rounds.ClassRoundSource;
var CompetitionRoundSource = models.rounds.CompetitionRoundSource;
var JudgingSource = models.judging.JudgingSource;
var RoundItem = models.rounds.RoundItem;
import { RoundAssignMatch } from './components/RoundAssignMatch';
import { Loading } from '../../../../base-react/components/Loading';
import { RoundOverviewSettings } from './components/RoundOverviewSettings';
import { RoundClassHierarchy } from './components/RoundClassHierarchy';
import { RoundMatchRace } from './components/RoundMatchRace';
import { HeaderContainer, BodyContainer } from '../../../../base-react/components/Container';
import { RoundPathParent } from '../../../components/RoundPathParent';
import { useCompetition } from '../../../../base-react/hooks/Competition';
import { PrioritizeTeams } from './components/PrioritizeTeams';
import { CopyTeamsClass } from './components/CopyTeamsClass';
const { Text, Title } = Typography;
const { useBreakpoint } = Grid;
export const Round = () => {
    var _a, _b, _c;
    const { event_id, competition_id, class_id, round_id } = useParams();
    const [inputCompetition, , , , , canEdit] = useCompetition(competition_id);
    const [rounds, loadingRounds] = Stream(ClassRoundSource(class_id));
    const [currentRound, setCurrentRound] = useState();
    const [allRounds] = Stream(currentRound && parseInt(currentRound.class_group_id) > 0 ? CompetitionRoundSource(currentRound.competition_id) : undefined);
    const [judging, loadingJudging] = Stream(inputCompetition && JudgingSource(inputCompetition.federation_id));
    const [floors, loadingFloors] = Stream(FloorSource(event_id));
    const [currentParentRound, setCurrentParentRound] = useState();
    const [currentRoundType, setCurrentRoundType] = useState();
    const [settingsDirty, setSettingsDirty] = useState(false);
    const screens = useBreakpoint();
    const navigate = useNavigate();
    useEffect(() => {
        if (round_id === 'new') {
            return;
        }
        if ([RoundType.Normal, RoundType.Chance, 'matchrace', RoundType.Points].includes(round_id)) {
            setCurrentRoundType(round_id);
        }
        else {
            const foundRound = rounds && rounds.find((a) => a.round_id === round_id);
            if (foundRound) {
                setCurrentRound(foundRound);
            }
        }
    }, [rounds, round_id]);
    useEffect(() => {
        if (currentRound) {
            const pathname = window.location.pathname;
            var newLocation = `${pathname}/../${currentRound.round_id}`;
            window.history.replaceState(null, '', newLocation);
        }
    }, [currentRound]);
    useEffect(() => {
        setSettingsDirty(false);
    }, [round_id]);
    if (loadingRounds || loadingJudging || loadingFloors) {
        return React.createElement(Loading, null);
    }
    const isSpecificRound = !!round_id && round_id !== 'new' && ![RoundType.Normal, RoundType.Chance, 'matchrace', RoundType.Points].includes(round_id);
    const creatingNewFromHierarchy = isSpecificRound && currentRoundType && !currentRound;
    if (isSpecificRound && !creatingNewFromHierarchy && rounds && !currentRound) {
        // Wait for the round to be resolved before rendering to avoid showing "new round" defaults
        return React.createElement(Loading, null);
    }
    let preliminaryJudging = judging === null || judging === void 0 ? void 0 : judging.find(a => a.judging_type === JudgingType.Select);
    const lastRound = currentParentRound ? currentParentRound : rounds && rounds.length > 0 ? rounds[rounds.length - 1] : null;
    const previewRound = (currentRound === null || currentRound === void 0 ? void 0 : currentRound.class_role) !== null ?
        allRounds === null || allRounds === void 0 ? void 0 : allRounds.find(a => a.class_group_id === (currentRound === null || currentRound === void 0 ? void 0 : currentRound.class_group_id) &&
            a.round_id !== (currentRound === null || currentRound === void 0 ? void 0 : currentRound.round_id) &&
            a.round_label === (currentRound === null || currentRound === void 0 ? void 0 : currentRound.round_label)) : null;
    let item = currentRound ? currentRound : {
        competition_id: competition_id,
        round_type: currentRoundType ? currentRoundType : RoundType.Normal,
        class_id: class_id,
        round_status: RoundStatus.Open,
        round_num_through: lastRound ? Math.floor(lastRound.round_num_through / 2) : 0,
        judging_id: lastRound ? lastRound.judging_id : preliminaryJudging === null || preliminaryJudging === void 0 ? void 0 : preliminaryJudging.judging_id,
        round_comment: "",
        round_num_heats: lastRound ? Math.max(Math.floor(lastRound.round_num_heats / 2), 1) : 1,
        round_heat_length: lastRound ? lastRound.round_heat_length : 180,
        schedule_id: lastRound ? lastRound.schedule_id : null,
        floor_id: lastRound ? lastRound.floor_id : ((floors && floors.length > 0) ? floors[0].floor_id : null),
        round_beat: lastRound ? lastRound.round_beat : null,
        round_force_beat: lastRound ? (lastRound.round_force_beat > 0 ? true : false) : false,
        round_position: lastRound ? lastRound.round_position : null,
        round_hide_results_pos: lastRound ? lastRound.round_hide_results_pos : null,
        round_hide_results_type: lastRound ? lastRound.round_hide_results_type : 'all',
        round_count: lastRound ? lastRound.round_count : 0,
        round_parent_id: currentParentRound ? currentParentRound.round_id : '0',
        round_label: currentRoundType == RoundType.Chance ? _T('round.chance').split(' - ')[0] : undefined
    };
    if (currentRoundType === RoundType.Points) {
        let noneJudging = judging === null || judging === void 0 ? void 0 : judging.find(a => a.judging_type === JudgingType.None);
        item.judging_id = noneJudging ? noneJudging.judging_id : "17";
        item.round_label = _T('round.points-round-label');
        item.round_num_heats = 1;
        item.round_num_through = 0;
        item.round_priority_settings = lastRound ?
            lastRound.round_priority_settings ?
                lastRound.round_priority_settings
                : JSON.stringify({ "type": "groups", "groups": [{
                            name: lastRound.class_label || lastRound.class_name,
                            class_id: lastRound.class_id
                        }] })
            : JSON.stringify({ "type": "groups" });
    }
    const isNew = item.round_id === undefined;
    const roundViewKey = (_a = item.round_id) !== null && _a !== void 0 ? _a : `new-${currentRoundType !== null && currentRoundType !== void 0 ? currentRoundType : 'round'}-${(_b = currentParentRound === null || currentParentRound === void 0 ? void 0 : currentParentRound.round_id) !== null && _b !== void 0 ? _b : 'root'}`;
    const speakerUrl = `/speaker-react/event/${event_id}`;
    const speakerAlertDescription = _T('team.merge.speaker-hint');
    const onChangeRound = (next) => {
        setSettingsDirty(false);
        setCurrentRound(next);
    };
    const onAddRound = (roundType, nextParentRound) => {
        setSettingsDirty(false);
        setCurrentRound(undefined);
        setCurrentRoundType(roundType);
        setCurrentParentRound(nextParentRound);
    };
    const onCancel = () => {
        if (isNew) {
            navigate('../classes');
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(HeaderContainer, null,
            React.createElement(Typography, null,
                React.createElement(Title, { level: screens.xs ? 3 : 1 }, isNew ? (currentParentRound ? (currentParentRound.round_label + ' - ') : '') +
                    _T('common.add', {
                        name: _T('round.' + (currentParentRound ? currentRoundType == RoundType.Normal ? 'child' : currentRoundType : currentRoundType === RoundType.Points ? 'points' : 'title'))
                    }) :
                    React.createElement(React.Fragment, null,
                        React.createElement(RoundPathParent, { record: item }, (round, parents) => React.createElement(Space, { wrap: true, separator: React.createElement(Divider, { orientation: 'vertical' }) },
                            (item.round_beat || item.floor_code) && React.createElement("span", null,
                                item.round_beat,
                                item.floor_code),
                            RoundItem.getClassLabel(item),
                            parents ? parents.map((parent, index) => React.createElement("div", { key: index }, RoundItem.getRoundLabel(parent))) :
                                RoundItem.getRoundLabel(round)))))),
            item.round_comment &&
                React.createElement(Text, null, item.round_comment)),
        React.createElement(BodyContainer, null,
            React.createElement(Space, { orientation: 'vertical', style: { width: '100%' } }, isNew ?
                currentRoundType === 'matchrace' ?
                    React.createElement(RoundMatchRace, { key: roundViewKey, round: currentParentRound, disabled: !canEdit }) :
                    React.createElement(RoundOverviewSettings, { key: roundViewKey, competition_id: competition_id, class_id: class_id, item: item, disabled: !canEdit, onCancel: onCancel, onDirtyChange: setSettingsDirty }) :
                React.createElement(React.Fragment, { key: roundViewKey },
                    React.createElement(RoundStatusView, { round: item, classRounds: rounds, disabled: !canEdit, hasChanges: settingsDirty }),
                    React.createElement(Row, { gutter: [12, 12] },
                        React.createElement(Col, { md: 24, lg: 16, style: { width: '100%' } },
                            React.createElement(RoundOverviewSettings, { competition_id: competition_id, class_id: class_id, item: item, disabled: !canEdit, onCancel: onCancel, onDirtyChange: setSettingsDirty })),
                        React.createElement(Col, { md: 24, lg: 8, style: { width: '100%' } },
                            React.createElement(RoundClassHierarchy, { event_id: event_id, class_id: class_id, round: item, classRounds: rounds, onChangeRound: onChangeRound, onAddRound: onAddRound, disabled: !canEdit }))),
                    !RoundItem.isFinalRound(item) &&
                        item.round_status == RoundStatus.Closed &&
                        (item.round_skating && item.round_skating.length > 0) &&
                        !RoundItem.usesPriority(item) &&
                        (item.round_type === RoundType.Chance || !RoundItem.isChildRound(item)) &&
                        (item.class_role === null ? parseInt(item.class_group_id) == 0 : true) &&
                        React.createElement(SendTeamsThrough, { round: item, classRounds: rounds, previewRound: previewRound, disabled: !canEdit }),
                    (RoundItem.usesPriority(item) && item.round_status == RoundStatus.Closed && item.round_type != RoundType.Points && canEdit) &&
                        React.createElement(PrioritizeTeams, { round: item, classRounds: rounds, previewRound: previewRound, disabled: !canEdit }),
                    RoundItem.usesPriority(item) && item.class_role === null && RoundItem.isLastRoundInClass(item, rounds) && item.round_status == RoundStatus.Confirmed && item.round_type != RoundType.Points && item.round_published === 0 && canEdit &&
                        React.createElement(CopyTeamsClass, { round: item, disabled: !canEdit }),
                    item.round_children > 0 &&
                        item.judging_type == JudgingType.Match &&
                        item.round_status == RoundStatus.Open &&
                        item.round_count > 0 &&
                        React.createElement(RoundAssignMatch, { round: item, classRounds: rounds, disabled: !canEdit }),
                    parseInt(item.class_group_id) > 0 && item.round_num_through > 0 && item.class_role === null &&
                        React.createElement(Alert, { title: _T('common.warnings'), description: _T('class.group.warning-confirm'), type: "warning", showIcon: true, closable: true }),
                    item.class_group_count > 0 &&
                        React.createElement(Alert, { title: _T('common.warnings'), description: _T('class.group.warning-wait'), type: "warning", showIcon: true, closable: true }),
                    (item.class_role_count > 0 || ((_c = RoundItem.getPrioritySettings(item)) === null || _c === void 0 ? void 0 : _c.type) === RoundPriorityType.Alternates && RoundItem.isLastRoundInClass(item, rounds)) &&
                        React.createElement(Alert, { title: _T('team.merge.title'), description: speakerAlertDescription, type: "info", showIcon: true, action: React.createElement(Button, { type: "primary", href: speakerUrl, target: "_blank", rel: "noopener noreferrer" }, _T('team.merge.speaker-link')), closable: true }),
                    React.createElement(RoundResult, { class_id: class_id, round: item, judging: judging && judging.find((judging) => judging.judging_id == item.judging_id), disabled: !canEdit }))))));
};
